import {
  Box,
  Image,
  useBreakpointValue,
  Text,
  Heading,
  Center,
  Button,
  Flex,
  Spinner,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./grid-component.css";
import { responsiveBg, mobileImage } from "../../utils/responsiveImage";
import { loadList } from "../../utils/siteData";

const VACANTE_URL = "https://vacante.travel-time.ro/";

const bgImage =
  " https://images.unsplash.com/photo-1495822892661-2ead864e1c7b?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

const GridComponent = ({
  images,
  titleHeading,
  descriptionHeading,
  titleHeading1,
  descriptionHeading1,
  titleHeading2,
  descriptionHeading2,
  titleHeading3,
  descriptionHeading3,
  titleHeading4,
  descriptionHeading4,
  titleHeading5,
  descriptionHeading5,
}) => {
  const [recommendedPosts, setRecommendedPosts] = useState([]);

  const getRandomRecommendedPosts = (data, count) => {
    const shuffled = data.slice().sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };

  useEffect(() => {
    // Postări recomandate: doar lista /data/lists/informatiiutile.json
    loadList("informatiiutile").then(setRecommendedPosts);
  }, []); // The empty dependency array ensures the effect runs once

  const history = useNavigate();

  const handleButtonClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Navigate to the '/vacante' route
    history.push("/vacante");
  };

  const columns = useBreakpointValue({ base: 1, md: 2 });
  const widthResponsive = useBreakpointValue({ base: "100%", md: "75%" });
  const widthResponsiveHeading = useBreakpointValue({
    base: "100%",
    md: "75%",
    lg: "50%",
  });
  const heightGrid = useBreakpointValue({
    base: "250px",
    lg: "300px",
  });
  const widthGrid = useBreakpointValue({
    base: "95%",
    lg: "75%",
  });

  const fontSizeTitleFilter = useBreakpointValue({ base: "2xl", lg: "6xl" });

  const fontSizeTitlePageWidth = useBreakpointValue({
    base: "100%",
    lg: "50%",
  });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Traficul din blog merge spre site-ul de vacanțe; UTM-urile arată în
  // Google Analytics (vacante.travel-time.ro) din ce articol și ce buton vine
  const { pathname } = useLocation();
  const vacanteUrl = (placement) =>
    `${VACANTE_URL}?utm_source=travel-time.ro&utm_medium=blog&utm_campaign=${encodeURIComponent(
      pathname.replace(/^\//, "")
    )}&utm_content=${placement}`;

  const ExternalLink = ({ to, children }) => (
    <Link
      to={to}
      style={{ color: "inherit", textDecoration: "inherit" }}
      onClick={scrollToTop} // Optionally scroll to top when the link is clicked
    >
      {children}
    </Link>
  );

  return (
    <>
      <Box
        bgImage={responsiveBg(bgImage)}
        bgSize="cover" // Adjust the background size as needed
        bgRepeat="no-repeat" // Set the background repeat
        bgPosition="center" // Set the background position
        p="100px" // Add padding if needed
        textAlign="center" // Center the content horizontally
      >
        <ExternalLink to={vacanteUrl("banner-sus")}>
          <Button
            colorScheme="teal"
            align="center"
            textAlign="center"
            type="submit"
            mt="10px"
            size="lg"
          >
            Rezervă-ți vacanța preferată!
          </Button>
        </ExternalLink>
      </Box>

      <Box
        borderColor="gray.100"
        borderWidth="2px"
        mt="10px"
        width={widthResponsive}
        mx="auto"
      >
        <Box width="100%" mx="auto">
          <Box position="relative" paddingBottom={"50%"}>
            {/* Pe telefon: varianta de 800px (display: contents = fără efect pe layout) */}
            <picture style={{ display: "contents" }}>
              <source
                media="(max-width: 47.99em)"
                srcSet={mobileImage(images[0].img).replace(/ /g, "%20")}
              />
              <Image
                src={images[0].img}
                alt={images[0].alt}
                fetchpriority="high"
                width="100%"
                height="100%"
                objectFit="cover"
                position="absolute"
                top="0"
                left="0"
                transform="scaleY(1)"
                transformOrigin="top"
              />
            </picture>
          </Box>
        </Box>

        <Box
          className="heading"
          width="100%"
          mx="auto"
          justifyContent="center"
          alignItems="center"
          p={4}
        >
          <Heading
            width={widthResponsiveHeading}
            mx="auto"
            background="teal"
            color="white"
            mt="7px"
            textAlign="center"
            size="lg"
            as="h1"
            mb={4}
          >
            {titleHeading}
          </Heading>
          <Text fontSize="xl" mb={6}>
            {descriptionHeading}
          </Text>
          <Heading as="h2" size="lg" mb={4}>
            {titleHeading1}
          </Heading>
          <Text fontSize="md" mb={6}>
            {descriptionHeading1}
          </Text>
          <Heading as="h3" size="lg" mb={4}>
            {titleHeading2}
          </Heading>
          <Text fontSize="md" mb={6}>
            {descriptionHeading2}
          </Text>
          <Heading as="h4" size="lg" mb={4}>
            {titleHeading3}
          </Heading>
          <Text fontSize="md" mb={6}>
            {descriptionHeading3}
          </Text>
          <Heading as="h5" size="lg" mb={4}>
            {titleHeading4}
          </Heading>
          <Text fontSize="md" mb={6}>
            {descriptionHeading4}
          </Text>
          <Heading as="h6" size="lg" mb={4}>
            {titleHeading5}
          </Heading>
          <Text fontSize="md" mb={6}>
            {descriptionHeading5}
          </Text>
        </Box>
        <Box p={4}>
          <Heading
            width={widthResponsiveHeading}
            mx="auto"
            textAlign="center"
            size="md"
            as="h2"
            color="teal"
          >
            Pentru o oferta personalizata:
          </Heading>
          <Link to="/contact">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                colorScheme="teal"
                align="center"
                type="submit"
                mt="10px"
                size="lg"
                _hover={{ bg: "rgba(255, 0, 0, 0.7)" }}
              >
                Contacteaza-ne!
              </Button>
            </div>
          </Link>
        </Box>
      </Box>

      <Box
        bgImage={responsiveBg(bgImage)}
        bgSize="cover" // Adjust the background size as needed
        bgRepeat="no-repeat" // Set the background repeat
        bgPosition="center" // Set the background position
        px={{ base: 6, md: "100px" }}
        py={{ base: "60px", md: "80px" }}
        textAlign="center" // Center the content horizontally
      >
        {/* Caseta de final de articol: trimite cititorii spre site-ul de vacanțe */}
        <Box
          bg="blackAlpha.500"
          color="white"
          borderRadius="lg"
          px={{ base: 5, md: 10 }}
          py={6}
          maxW="640px"
          mx="auto"
        >
          <Heading as="h2" size="lg" mb={3} fontFamily="Montserrat">
            Ți-ai făcut poftă de vacanță?
          </Heading>
          <Text fontSize="lg" mb={2}>
            Pe vacante.travel-time.ro găsești sejururi cu avionul sau cu
            autocarul, circuite și hoteluri, cu rezervare online.
          </Text>
          <ExternalLink to={vacanteUrl("caseta-final")}>
            <Button
              colorScheme="teal"
              align="center"
              textAlign="center"
              type="submit"
              mt="10px"
              size="lg"
            >
              Rezervă-ți vacanța preferată!
            </Button>
          </ExternalLink>
        </Box>
      </Box>

      <Center mt="10">
        <Heading>- Postari Recomandate -</Heading>
      </Center>

      {/* Render the recommended posts */}
      {recommendedPosts ? (
        <Flex mt="15px" flexWrap="wrap" justifyContent="center">
          <Grid templateColumns={`repeat(${columns}, 1fr)`} gap={3} w="100%">
            {getRandomRecommendedPosts(recommendedPosts, 6).map(
              (post, index) => {
                // Define albumHref here for each post
                const albumHref = "/" + post.id + "/";

                return (
                  <Box mb={6}>
                    <GridItem position="relative" width={widthGrid} mx="auto">
                      <Box
                        className="description-title"
                        mx="auto"
                        p={2}
                        mb={3}
                        boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                        display="flex"
                        justifyContent="center"
                        background="teal"
                        color="white"
                        fontWeight="bold"
                        fontSize="1.2rem"
                      >
                        {post.description}
                      </Box>
                      <a href={albumHref}>
                        <Image
                          src={post.thumbnail}
                          loading="lazy"
                          alt={post.alt}
                          w="100%"
                          h={heightGrid}
                          objectFit="cover"
                        />
                      </a>
                      <a href={albumHref}>
                        <Button
                          position="absolute"
                          bottom={0}
                          right={0}
                          size="sm"
                          colorScheme="black"
                          p={3}
                          mb={3}
                          mr={3}
                          fontSize="1.2rem"
                          type="button"
                          border="1px"
                          _hover={{ bg: "white", color: "black" }}
                        >
                          Mai multe informatii
                        </Button>
                      </a>
                    </GridItem>
                  </Box>
                );
              }
            )}
            ;
          </Grid>
          <Link to="/blog">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={handleButtonClick}
                colorScheme="teal"
                align="center"
                type="submit"
                mt="10px"
                size="lg"
                _hover={{ bg: "rgba(255, 0, 0, 0.7)" }}
              >
                Revino la Blog
              </Button>
            </div>
          </Link>
        </Flex>
      ) : (
        <Flex justifyContent="center" alignItems="center" height="100vh">
          <Spinner size="xl" />
        </Flex>
      )}

      <Box
        bgImage={responsiveBg(bgImage)}
        bgSize="cover" // Adjust the background size as needed
        bgRepeat="no-repeat" // Set the background repeat
        bgPosition="center" // Set the background position
        p="100px" // Add padding if needed
        textAlign="center" // Center the content horizontally
        mt="10"
      >
        <ExternalLink to={vacanteUrl("banner")}>
          <Button
            colorScheme="teal"
            align="center"
            textAlign="center"
            type="submit"
            mt="10px"
            size="lg"
          >
            Rezervă-ți vacanța preferată!
          </Button>
        </ExternalLink>
      </Box>
    </>
  );
};

export default GridComponent;
